<template>
    <div>
        <slglrs-base-header-sec title="СЛУЖБЕНИ ГЛАСНИК РС" slug="NP"></slglrs-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Врста документа</label>
                                <div class=" mb-2">
                                    <div class="custom-control custom-radio mr-3">
                                        <input type="radio" v-model="documentType" class="custom-control-input" value="laws"
                                            id="customRadioInline1">
                                        <label class="custom-control-label" for="customRadioInline1"
                                            value="laws">прописи</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" v-model="documentType" class="custom-control-input" value="ads"
                                            id="customRadioInline2">
                                        <label class="custom-control-label" for="customRadioInline2"
                                            value="ads">огласи</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm np">
                                <div class="form-label-spacer"></div>
                                <!-- <select class="form-control" multiple="" size="4" v-model="docTypeIds">
                                    <option selected disabled hidden value="-1">Сви</option>
                                    <option v-for="item in docTypes" :label="item.l" :value="item.k"
                                            v-bind:key="item.k">{{item.l}}
                                    </option>
                                </select> -->
                                <multiselect v-model="docTypeIds" :options="docTypes" :multiple="true" placeholder="Сви"
                                    track-by="k" label="l" :show-labels="false"></multiselect>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm np">
                                <label class="form-label">Доносилац</label>
                                <!-- <select id="br_god" multiple="" class="form-control full-width" size="4"
                                        v-model="authorityIds" :disabled="documentType !== 'laws'">
                                    <option selected disabled hidden value="-1">Сви</option>
                                    <option v-for="item in filters.authorities" v-bind:key="item.k"
                                            :label="item.l" :value="item.k" selected="selected">{{item.l}}
                                    </option>
                                </select> -->
                                <multiselect v-model="authorityIds" :options="filters.authorities" :multiple="true"
                                    placeholder="Сви" track-by="k" label="l" :disabled="documentType !== 'laws'"
                                    :show-labels="false"></multiselect>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group form-group-sm">
                                <label for="number" class="form-label">Број гласила</label>
                                <input type="text" v-model="number" id="number" class="form-control full-width">
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="title_query" class="form-label">Речи садржане у наслову</label>
                        <div class="input-group ">
                            <input id="title_query" v-model="title_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="title_query_all" v-model="title_query_all">
                                    <label class="in-btn-form-label" for="title_query_all">Све ове речи</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm">
                        <label for="text_query" class="form-label">Речи садржане у тексту</label>
                        <div class="input-group ">
                            <input id="text_query" v-model="text_query" type="text" class="form-control full-width">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <input type="checkbox" class="mr-2" id="text_query_all" v-model="text_query_all">
                                    <label class="in-btn-form-label" for="text_query_all">Све ове речи</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <result-counter v-if="searchResult !== null" :count="searchResult.resultSize"
                :limit="searchResult.limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="timestamp"-->
                <!--                              dir="desc"-->
                <!--                              class="table  table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="name">Назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: left; width: 10rem;">-->
                <!--                            <sort-link name="number">Број</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: left; width: 10rem;">-->
                <!--                            <sort-link name="authority">Доносилац</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: left; width: 10rem;">-->
                <!--                            <sort-link name="docType">Врста документа</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: left; width: 10rem;">-->
                <!--                            <sort-link name="timestamp">Датум</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(row, index) in sort.values" :key="index">-->
                <!--                            <td>-->

                <!--                                &lt;!&ndash;    <router-link  :to=" '/slglrs/viewAct/naziv-akta/' + row.id"&ndash;&gt;-->
                <!--                                <a @click.stop.prevent="buildLink(row.id)"-->
                <!--                                   :href="baseApiUrl + 'slglrs/viewAct/' + row.id"-->
                <!--                                   target="_blank"> {{ row.name }}</a>-->
                <!--                                <hr>-->
                <!--                                &lt;!&ndash;                                <a :href="baseApiUrl +'slglrs/viewAct/' + row.id"&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                   target="_blank"&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                > {{row.name}}</a>&ndash;&gt;-->

                <!--                            </td>-->
                <!--                            <td>{{ row.number}}</td>-->
                <!--                            <td>{{ row.authority }}</td>-->
                <!--                            <td>{{ row.docType }}</td>-->
                <!--                            <td>{{ row.date }}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->


                <!--
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                -->
                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields" responsive="sm">

                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/slglrs/viewAct/' + data.item.id }">
                            {{ data.item.name }}
                        </router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SlglrsBaseHeaderSec from '@/base_pages/slglrs/SlglrsBaseHeaderSec.vue';
import ResultCounter from '@/partials/ResultCounter.vue';

import { mapState } from 'vuex';

export default {
    name: "SlglrsNP_SearchPage",
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
            authorityType: null,
            documentType: null,
            docTypes: [],

            number: '',
            title_query: '',
            text_query: '',
            title_query_all: true,
            text_query_all: true,
            authorityIds: [],
            docTypeIds: [],
            yearFrom: null,
            yearTo: null,
            resultLimit: 50,

            filters: {
                docTypesLaws: [],
                docTypesAds: [],
                authorities: [],
            },
            searchResult: null,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },

            fields: [
                { label: 'Назив', key: 'name', sortable: true },
                { label: 'Број', key: 'number', sortable: true },
                { label: 'Доносилац', key: 'authority', sortable: true },
                { label: 'Врста документа', key: 'docType', sortable: true },
                { label: 'Датум', key: 'timestamp', sortable: true }
            ],


        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    computed: {
        ...mapState(['userInfoState']),

        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('NP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    components: {
        SlglrsBaseHeaderSec,
        ResultCounter
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        openAct(actId) {
            axios.get(this.baseApiUrl + 'api/RegistarServlet/act-' + actId).then(response => {
                this.actHTML = response.data
            });
            this.isActOpen = true;
        },
        fetchData() {
            axios.get(this.baseSLGLApiUrl + 'Prins/NP/searchFilterInfo')
                .then(response => {
                    this.filters = response.data;
                    this.reset();
                });
        },
        search() {
            let dids = [];
            this.docTypeIds.filter(obj => {
                dids.push(obj.k);
            });

            let aids = [];
            this.authorityIds.filter(obj => {
                aids.push(obj.k);
            });

            var url = this.baseDIApiUrl + 'NP/search';
            const vm = this;
            var data = {
                bk: this.text_query === '' ? null : this.text_query,
                tk: this.title_query === '' ? null : this.title_query,
                bmo: this.text_query_all,
                tmo: this.title_query_all,
                limit: this.resultLimit,
                yf: this.yearFrom,
                yt: this.yearTo,
                n: this.number === '' ? null : this.number,
                aids: aids,
                dids: dids,
                il: this.documentType === 'laws',
            };

            axios.post(url, data).then(response => {
                this.searchResult = response.data;
                var data = response.data.result;
                for (var i = 0; i < data.length; i++) {
                    data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                }
                this.result = data;
                this.resultSize = response.data.resultSize;
            }).catch(function (error) {
                if (error.response.status === 401) {
                    // nije ulogovan
                    // otvori modal za logovanje
                    vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                }
                console.log(error);
            });

        },
        reset() {
            this.documentType = 'laws';

            this.number = '';
            this.docTypeIds = [];
            this.authorityIds = [];

            if (this.$route.query.q) {
                this.title_query = this.$route.query.q;
            } else {
                this.title_query = '';
            }
            this.text_query = '';
            this.title_query_all = true;
            this.text_query_all = true;

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;
            this.searchResult = null;
        }
    },
    watch: {
        documentType: function () {
            this.docTypeIds = [];
            this.authorityIds = [];
            if (this.documentType === 'laws') {
                this.docTypes = this.filters.docTypesLaws;
            } else this.docTypes = this.filters.docTypesAds;
        },
        // resultLimit: function () {
        //     this.resultSize = null;
        // }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        if (this.$route.query.q) {
            this.title_query = this.$route.query.q;
            this.search();
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_slglrs';
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.table-bootstrap-vue thead tr th:first-child {
    width: 50%;
}

.np .multiselect__tag {
    background: #409edc !important;
    margin-top: 4px;
}

.np .multiselect__placeholder {
    color: black !important;
    font-size: 0.9rem;
}

.np .multiselect__select:before {
    border-color: black transparent transparent !important;
    border-width: 6px 3px 0 !important;
    opacity: 0.8;
}

.np .multiselect__tags {
    border-radius: unset !important;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.22);
    padding: 4px 40px 0 12px !important;
    border: 1px solid #ced4da;
    /* background: #409edc!important;  */
    /* background: #409edc!important;  */

}

.np .multiselect {
    min-height: 35px;
}

.multiselect__select {
    top: 4px !important;
    right: -9px !important;
}

#__BVID__116 {
    margin-top: -2px;
}

.np .multiselect__tag-icon {
    background: #409edc !important;
}

.np .multiselect__tag-icon:hover {
    background: #6baad4 !important;
}

.np .multiselect__option--highlight {
    background: #409edc !important;
}
</style>
